import { RootState } from 'store';
import { IReportData, IReportsDataList } from 'types';

export const getReportsSelector = (store: RootState): IReportData[] | [] => store.reports.reportsList || [];
export const getReportsListSelector = (store: RootState): IReportsDataList[] | [] => store.reports.reportListById || [];
export const getReportsLoadingSelector = (store: RootState): boolean => store.reports.isLoading;
